// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-expect-error
import "@fontsource/shippori-antique";
import "./index.css"

import "./i18n/config";
import {createRoot} from "react-dom/client";
import {StrictMode} from "react";
import {AppThemeProvider} from "./theme.tsx";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {AppRouterProvider} from "./routing/AppRouterProvider.tsx";
import {MothershipProvider} from "./rpc/mama.tsx";
import {AuthenticatorProvider} from "./auth/authenticator.tsx";
import {TanstackQueryProvider} from "./tq/tqbedrock.tsx";
import {bedrockTqKeys} from "./tq/bedrockKeys.ts";
import {BombProvider} from "./bomb/bomb.tsx";

function App() {
    return (
        <AppThemeProvider>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
                <BombProvider>
                    <TanstackQueryProvider bedrockKeys={bedrockTqKeys}>
                        <AuthenticatorProvider>
                            <MothershipProvider>
                                <AppRouterProvider/>
                            </MothershipProvider>
                        </AuthenticatorProvider>
                    </TanstackQueryProvider>
                </BombProvider>
            </LocalizationProvider>
        </AppThemeProvider>
    );
}

const rootElem = document.getElementById("root");
if (rootElem) {
    const root = createRoot(rootElem);
    if (import.meta.env.DEV) {
        root.render(<StrictMode><App/></StrictMode>);
    } else {
        root.render(<App/>);
    }
}

